const sessionsProvider = {
  getStudentSessions: async (params) => {
    const apiUrl = process.env.REACT_APP_BACKEND_HOST;
    const url = `${apiUrl}/v1/students/${params.studentId}/sessions`;
    return { url };
  },
};

export default sessionsProvider;
